<template lang="pug">
  .PostContentAlsoLike.content-also-like
    .content-also-like__title-row
      .is-h2__title.content-also-like__title You Might Also Like
      hr.content-also-like__hr
    .content-also-like__items
      PostThumbnailSmall.content-also-like__item(
        v-for="item in data.youMightAlsoLikePosts",
        :key="item.slug",
        :data="item"
        :show-category="showThumbnailCategory",
        :to="item.route",
      )
</template>

<script>
import { BasePostClass } from 'Classes';
import PostThumbnailSmall from 'Components/PostThumbnailSmall/PostThumbnailSmall';

export default {
  name: 'PostContentAlsoLike',
  components: {
    PostThumbnailSmall,
  },
  props: {
    data: {
      type: BasePostClass,
      required: true,
    },
    showThumbnailCategory: Boolean,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.content-also-like
  &__title
    flex-shrink: 0
    margin-bottom: 0
    margin-right: 10px
    @media screen and (max-width: 767px)
      margin-right: 0
  &__hr
    width: 100%
    margin-bottom: 13px
    border-width: 2px
    @media screen and (max-width: 767px)
      display: none
  &__title-row
    display: flex
    flex-direction: row
    align-items: flex-end
    margin-bottom: 30px
    @media screen and (max-width: 767px)
      justify-content: center
  &__items
    margin: 0 -15px
    display: flex
    flex-direction: row
    flex-wrap: wrap
    @media screen and (max-width: 1170px)
      justify-content: center
  &__item
    margin-bottom: 0
    @media screen and (max-width: 779px)
      &:not(:first-child)
        margin-top: 50px
    &:last-child
      &:not(&:first-child)
        @media screen and (max-width: 1170px)
          margin-top: 50px
</style>
